module.exports = __webpack_public_path__ + "static/media/37-2.e8f95ba3.mp3";